export default "__VITE_ASSET__C_D4e5JH__"